<!-- router-view 结合 keep-alive 组件 -->
<template>
  <transition :name="transitionName" mode="out-in" appear>
    <keep-alive :include="include">
      <div class="layout-content">
        <router-view />
      </div>
    </keep-alive>
  </transition>
</template>

<script>
  export default {
    name: 'RouterLayout',
    computed: {
      include() {
        return this.$store.getters['theme/keepAliveInclude'] ?? []
      },
      transitionName() {
        return this.$store.state.theme.transitionName
      }
    }
  }
</script>

<style lang="scss" scoped>
  .layout-content {
    padding: var(--layout-content-padding);
    height: calc(
      100vh - var(--layout-header-height) - var(--layout-footer-height)
    );
  }
</style>
